import React, {useState, useEffect} from 'react';

export default function BalanceFooter({content}) {

    const getOffset = (element) => {
        const elementRect = element?.getBoundingClientRect();
        return elementRect?.top
    }

    const calcInit = () => {
        if(window !== undefined) {
            const heightToHide = getOffset(document.getElementById('fertilizer-calculation'))
            let windowHeight = window.scrollY + document.documentElement.clientHeight;
            let scrollHeight = Math.max(
                document.body.scrollHeight, document.documentElement.scrollHeight,
                document.body.offsetHeight, document.documentElement.offsetHeight,
                document.body.clientHeight, document.documentElement.clientHeight
            );
            const windowScrollHeight = document.body.scrollTop || document.documentElement.scrollTop;
            const bottomHeightToHide = document.getElementById('fertilizer-calculation')?.getBoundingClientRect()?.bottom
            if (windowHeight-windowScrollHeight<heightToHide+200) {
                return (windowHeight < (scrollHeight - 100) ? [false,'sticky-footer']:[false,'balance_calculation_table']);
            } else if (windowHeight-windowScrollHeight<bottomHeightToHide+50) {
                return [true, 'sticky-footer']
            }else {
                return [true, 'balance_calculation_table']
            }
        }else return [false, 'balance_calculation_table']
    }
    const initial_state = calcInit()
    const [isVisible, setIsVisible] = useState(initial_state[0]);
    const [stickyClass, setStickyClass] = useState(initial_state[1]);

    useEffect(() => {
        window.addEventListener('scroll', stickNavbar);
        const listenToScroll = () => {
            if (window !== undefined) {
                const heightToHide = getOffset(document.getElementById('fertilizer-calculation'))
                let windowHeight = window.scrollY + document.documentElement.clientHeight;
                const windowScrollHeight = document.body.scrollTop || document.documentElement.scrollTop;
                const bottomHeightToHide = document.getElementById('fertilizer-calculation')?.getBoundingClientRect()?.bottom
                if (windowHeight-windowScrollHeight<heightToHide+200) {
                    setIsVisible(false)
                } else if (windowHeight-windowScrollHeight<bottomHeightToHide+50) {

                    setIsVisible(true)
                    setStickyClass('sticky-footer')
                }else {
                    setIsVisible(true)
                    setStickyClass('balance_calculation_table')
                }
            }
        }
        return () => window.removeEventListener('scroll', listenToScroll);
    }, []);

    useEffect(() => {
        const listenToScroll = () => {
            if (window !== undefined) {
                const heightToHide = getOffset(document.getElementById('fertilizer-calculation'))
                let windowHeight = window.scrollY + document.documentElement.clientHeight;
                const windowScrollHeight = document.body.scrollTop || document.documentElement.scrollTop;
                const bottomHeightToHide = document.getElementById('fertilizer-calculation')?.getBoundingClientRect()?.bottom
                if (windowHeight-windowScrollHeight<heightToHide+200) {
                    setIsVisible(false)
                } else if (windowHeight-windowScrollHeight<bottomHeightToHide+50) {

                    setIsVisible(true)
                    setStickyClass('sticky-footer')
                }else {
                    setIsVisible(true)
                    setStickyClass('balance_calculation_table')
                }
            }
        }
        window.addEventListener('scroll', listenToScroll);
        return () => window.removeEventListener('scroll', listenToScroll);
    }, []);




    const stickNavbar = () => {
        if (window !== undefined) {
            let windowHeight = window.scrollY + document.documentElement.clientHeight;
            let scrollHeight = Math.max(
                document.body.scrollHeight, document.documentElement.scrollHeight,
                document.body.offsetHeight, document.documentElement.offsetHeight,
                document.body.clientHeight, document.documentElement.clientHeight
            );
            windowHeight < (scrollHeight - 100) ? setStickyClass('sticky-footer') : setStickyClass('balance_calculation_table');
        }
    };

    return isVisible ? <div className={`${stickyClass}`}>{content}</div> : <></>;
}
